import type { BuyRequest, Product } from '@/js/services/RogueTypes'

/**
 * The 500LB and 1000LB bumper sets are a custom mix of plates rather than a fixed assortment, so the
 * customer has to pick a breakdown. Every other set ships a pre-set amount of weights.
 *
 * Matched on the swatch label because two product lines behave this way (mil-spec WE0003-500/-1000 and
 * deep dish USC0003-500/-1000), and `lib-payments` keys the order comment off the same two labels.
 */
export const BUMPER_SET_LABELS = ['500LB Set', '1000LB Set']

export function needsBumperSetBreakdown(product?: Product): boolean {
  return BUMPER_SET_LABELS.includes(String(product?.attributes?.rogue_swatch_label))
}

/**
 * Whether a buy request for one of those sets is still missing its breakdown.
 *
 * Deliberately keyed off the selections rather than the `plateSetValid` flag alone: items saved before
 * that flag existed carry real selections without it, and flagging those would block a valid cart.
 */
export function missingBumperSetBreakdown(buyRequest: BuyRequest, products: {[key: string]: Product}): boolean {
  if (!needsBumperSetBreakdown(products[buyRequest.productId])) {
    return false
  }

  // An explicit `false` means the selector ran and the weight didn't add up
  if (buyRequest.metadata?.plateSetValid === false) {
    return true
  }

  // Nothing picked - either the item never passed through the selector (the wishlist/registry path)
  // or every plate was zeroed out
  return !buyRequest.metadata?.plateOpts?.some(opt => opt.qty > 0)
}
